(() => {
  if (!document.body.hasAttribute('data-sm-bn-design')) return;
  const strings=JSON.parse(document.querySelector('[data-sm-bn-strings]')?.textContent||'{}');
  function tick(){
    const now=Date.now();
    document.querySelectorAll('[data-sm-countdown]').forEach(el=>{
      const start=Date.parse(el.dataset.start),end=Date.parse(el.dataset.end);
      if(!Number.isFinite(start)||!Number.isFinite(end))return;
      const remaining=Math.max(0,Math.floor(((now<start?start:end)-now)/1000));
      const label=remaining?(now<start?strings.starts:strings.ends):strings.ended;
      const time=remaining?[Math.floor(remaining/86400)+'d',String(Math.floor(remaining/3600)%24).padStart(2,'0')+'t',String(Math.floor(remaining/60)%60).padStart(2,'0')+'m',String(remaining%60).padStart(2,'0')+'s'].join(' : '):'';
      el.querySelector('[data-sm-clock-label]').textContent=label;
      el.querySelector('[data-sm-clock]').textContent=time;
      el.setAttribute('aria-label',label+' '+Math.ceil(remaining/86400)+' dage');
    });
  }
  document.addEventListener('click',async e=>{
    const button=e.target.closest('[data-sm-copy]');if(!button)return;
    try{await navigator.clipboard.writeText(button.dataset.smCopy);document.querySelector('[data-sm-copy-status]').textContent=strings.copied;}catch{}
  });
  tick();setInterval(()=>{if(!document.hidden)tick();},1000);
  document.addEventListener('visibilitychange',tick);
  document.addEventListener('shopify:section:load',tick);
})();
